import React from "react";

const Approach = () => {
  return (
    <div className="bg-black py-10 sm:py-20 lg:py-20">
      <div className="max-w-5xl mx-auto px-6">
        {/* Section heading */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-gray-400 mb-3 sm:mb-4">
            Approach
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-thin leading-snug">
            The Art of <em>Responsible Innovation</em>
          </h2>
        </div>

        {/* Three pillars */}
        <div className="grid md:grid-cols-3 gap-10 sm:gap-12 lg:gap-16">
          <div className="text-center">
            <div className="w-px h-16 sm:h-20 bg-gradient-to-b from-transparent via-white to-transparent mx-auto mb-6 sm:mb-8" />
            <h3 className="text-lg sm:text-xl font-light mb-4 sm:mb-6 tracking-wide">
              Cultural Intelligence
            </h3>
            <p className="text-gray-400 leading-relaxed font-light text-sm sm:text-base">
              Context-first AI governance that honors cultural nuances while enabling global competitiveness.
            </p>
          </div>

          <div className="text-center">
            <div className="w-px h-16 sm:h-20 bg-gradient-to-b from-transparent via-white to-transparent mx-auto mb-6 sm:mb-8" />
            <h3 className="text-lg sm:text-xl font-light mb-4 sm:mb-6 tracking-wide">
              Inclusive Access
            </h3>
            <p className="text-gray-400 leading-relaxed font-light text-sm sm:text-base">
              Breaking down barriers to ensure AI education reaches every professional ready to transform.
            </p>
          </div>

          <div className="text-center">
            <div className="w-px h-16 sm:h-20 bg-gradient-to-b from-transparent via-white to-transparent mx-auto mb-6 sm:mb-8" />
            <h3 className="text-lg sm:text-xl font-light mb-4 sm:mb-6 tracking-wide">
              Measurable Impact
            </h3>
            <p className="text-gray-400 leading-relaxed font-light text-sm sm:text-base">
              Moving beyond theory to deliver ROI-focused training and sustainable implementation strategies.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Approach;
